import React, { createRef } from 'react';
import { change } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import axios from 'axios';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import { googleMapLoader } from '../../../helpers/googleMapLoader';
import debounce from '../../../helpers/debounce';
import messages from '../../../locale/messages';

import { autoCompleteURL, placeDetailURL } from '../../../config';
import { getConfigSettings } from '../../../helpers/getConfigSettings';

class PlaceGeoSuggest extends React.Component {

    static defaultProps = {
        label: '',
        className: '',
        defaultValue: '',
        containerClassName: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            value: props?.initialValue ? props?.initialValue : null,
            suggestion: [],
            googleMapsApiLoaded: false,
            errorMessageChange: false
        };
        this.dropdownRef = createRef();
    }

    async componentDidMount() {
        const { id, initialValue } = this.props;
        this.setState({ value: initialValue });
        await googleMapLoader();
        this.setState({ googleMapsApiLoaded: true });
        const isDocument = typeof document !== undefined;
        if (isDocument) {
            document.addEventListener('mousedown', this.handleClickOutside);
            document.addEventListener('touchstart', this.handleClickOutside);
        }
    }

    componentWillUnmount() {
        const isDocument = typeof document !== undefined;
        if (isDocument) {
            document.addEventListener('mousedown', this.handleClickOutside);
            document.addEventListener('touchstart', this.handleClickOutside);
        }
    }

    handleClickOutside = (event) => {
        const { id } = this.props;
        if (this.dropdownRef?.current && !this.dropdownRef?.current?.contains(event?.target)) {
            this.setState({ suggestion: [] });
            const parentSection = document.getElementById('safariFailureGeoSuggestionDropDown' + id);
            const childSection = document.getElementById('suggestItem' + id);
            if (parentSection && childSection) {
                parentSection.removeChild(childSection);
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { locale, intl } = nextProps;
        const { locale: oldLocale } = this.props;
        const { value, errorMessageChange } = this.state;
        if (oldLocale == locale && errorMessageChange) {
            this.handleGeoSuggestFailure({ target: { value } }, intl.formatMessage(messages.locationWarning));
        }
        this.setState({ errorMessageChange: oldLocale != locale });
    }

    handleAutoComplete = debounce(async (e) => {
        const { onChange } = this.props;
        const value = e;
        onChange && onChange(value);
        const configData = await getConfigSettings({ name: ['googleMapBrowserApiKey'] })

        if (value?.length > 0) {
            const requestData = { input: value };
            axios.post(autoCompleteURL, requestData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Goog-Api-Key': configData?.googleMapBrowserApiKey
                    }
                }
            ).then(response => {
                if (response?.data?.suggestions?.length > 0) {
                    this.setState({
                        suggestion: response?.data?.suggestions
                    });
                }
            }).catch(error => {
                console.error('Error:', error?.response ? error?.response?.data : error?.message);
            });

        }
    }, 100)

    handleSuggest = async ({ placeId, value }) => {
        const { handleSelectSuggest } = this.props;
        const configData = await getConfigSettings({ name: ['googleMapBrowserApiKey'] })

        if (placeId) {
            try {
                const response = await axios.get(`${placeDetailURL}${placeId}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Goog-Api-Key': configData?.googleMapBrowserApiKey,
                        'X-Goog-FieldMask': '*'
                    }
                });
                if (response?.data) {
                    handleSelectSuggest(response?.data, value);
                    this.setState({ value, suggestion: [] });
                }
            } catch (error) {
                console.error('Place Details Error:', error?.response?.data || error?.message);
            }
        }
    }

    handleGeoSuggestFailure = (e, message) => {
        const { id } = this.props;
        const { formatMessage } = this.props.intl;
        const { errorMessageChange } = this.state;
        const suggestionsContainer = document.getElementById('safariFailureGeoSuggestionDropDown' + id);
        if (suggestionsContainer) {
            suggestionsContainer.style.display = "block";
            let suggestionItem = document.createElement("div");
            suggestionItem.id = 'suggestItem' + id;
            suggestionItem.classList.add('suggestItem')
            suggestionItem.textContent = formatMessage(messages.locationWarning);
            if (e.target.value != "") {
                if (!document.getElementById('suggestItem' + id)) {
                    suggestionsContainer.appendChild(suggestionItem);
                } else if (errorMessageChange && message) {
                    suggestionItem.textContent = message;
                    suggestionsContainer.replaceChild(suggestionItem, document.getElementById('suggestItem' + id));
                    this.setState({ errorMessageChange: false })
                }
            } else {
                const parentSection = document.getElementById('safariFailureGeoSuggestionDropDown' + id);
                const childSection = document.getElementById('suggestItem' + id);
                if (parentSection && childSection) {
                    parentSection.removeChild(childSection);
                }
            }
            this.setState({ value: e.target.value });
        }
    }


    render() {
        const { label, id, inputClass, containerClassName, disabled } = this.props;
        const { googleMapsApiLoaded, value, suggestion } = this.state;

        return (
            <div ref={this.dropdownRef} className={containerClassName}>
                {
                    googleMapsApiLoaded ?
                        <div className='manualGeoSuggestContainer position-relative'>
                            <input
                                id={id}
                                type='text'
                                placeholder={label ? label : ''}
                                value={value}
                                disabled={disabled}
                                autoComplete='off'
                                className={cx(inputClass, "w-100")}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    this.setState({ value: val });
                                    if (val.trim() === "") {
                                        this.props.onChange(null);
                                        this.setState({ suggestion: [] });
                                        return;
                                    }
                                
                                    this.handleAutoComplete(val);
                                }}
                            />
                            {
                                suggestion?.length > 0 && (
                                    <ul className='manualGeoSuggestListWrapper'>
                                        {
                                            suggestion?.map((item, itemIndex) => {
                                                return (
                                                    <li key={itemIndex} className='manualGeoSuggestList'
                                                        onClick={() => this.handleSuggest({ placeId: item?.placePrediction?.placeId, value: item?.placePrediction?.text?.text })}
                                                    >
                                                        {item?.placePrediction?.text?.text}
                                                    </li>
                                                )
                                            })}
                                    </ul>
                                )
                            }
                        </div> :
                        <div className='manualGeoSuggestContainer position-relative'>
                            <input
                                type='text'
                                placeholder={label ? label : ''}
                                value={value}
                                className={cx(inputClass, "w-100")}
                                autoComplete='off'
                                onChange={(e) => this.handleGeoSuggestFailure(e)}
                            />
                            <div id={'safariFailureGeoSuggestionDropDown' + id} className='safariManualGeoSuggestListWrapper' />
                        </div>
                }
            </div>
        );
    }
}

const mapState = (state) => ({});

const mapDispatch = {
    change
};

export default injectIntl((connect(mapState, mapDispatch)(PlaceGeoSuggest)));
